var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pages-salesccenter"},[(_vm.iframeUrl)?_c('iframe',{ref:"iframe",attrs:{"id":"iframe-salescenter","src":_vm.iframeUrl,"height":"100%","frameborder":"no","border":"0","marginwidth":"0","marginheight":"0","scrolling":"no"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }